import type { components } from '@/types/api/v1'
import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { daysOfTheWeek } from '../utils'
import { ShiftTile } from './ShiftTile'
type ShiftTileListProps = {
  days?: Array<components['schemas']['ScheduleDay']>
  offsetDay?: number
  onChange?: (val: { value: components['schemas']['ScheduleDay']; index: number }) => void
}

const getDayName = (index: number, offset = 0) => daysOfTheWeek[(index + offset) % 7]

export function ShiftTileList({ days, offsetDay, onChange }: ShiftTileListProps) {
  return (
    <Horizontal
      flex='0'
      style={{
        overflow: 'visible',
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fill, minmax(120px, 1fr))`,
        gap: 8,
        maxWidth: '100%',
      }}
    >
      {days?.map((day, i) => (
        <Vertical key={`shift-${i}-${day.shift}`} flex='0' style={{ overflow: 'visible', textAlign: 'center' }}>
          <Texto category='label'>{days.length !== 7 ? `Day ${i + 1}` : getDayName(i, offsetDay)}</Texto>
          <Vertical gap={8} flex='0' style={{ overflow: 'visible', marginTop: 8 }}>
            <ShiftTile value={day} onChange={onChange ? (value) => onChange({ value, index: i }) : undefined} />
          </Vertical>
        </Vertical>
      ))}
    </Horizontal>
  )
}
